import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AboutComponent } from './about.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    CollapseModule,
    SharedModule
  ],
  declarations: [AboutComponent],
  exports: [AboutComponent],
  entryComponents: [
    AboutComponent
  ]
})
export class AboutModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/about/about.module.ts